// Logos of the assistances a case can be handled under, keyed by the assistance short name
// core sends (e.g. MONDIAL → images/assistances/mondial.png). The file name is the mapping,
// so supporting a new assistance only takes dropping its logo in that directory.
const logos = import.meta.glob('../images/assistances/*.png', { eager: true, import: 'default' });

const logosByKey = Object.fromEntries(
  Object.entries(logos).map(([path, url]) => [path.split('/').pop().replace(/\.png$/, ''), url])
);

// URL of the bundled logo for the given assistance short name, or null when no logo ships
// for it, so the caller can simply skip rendering.
export function assistanceLogoUrl(key) {
  if (!key) return null;

  return logosByKey[String(key).toLowerCase()] || null;
}
